import { render, staticRenderFns } from "./r-item-state-dialog.vue?vue&type=template&id=6a2eebfc&scoped=true"
import script from "./r-item-state-dialog.vue?vue&type=script&lang=js"
export * from "./r-item-state-dialog.vue?vue&type=script&lang=js"
import style0 from "./r-item-state-dialog.vue?vue&type=style&index=0&id=6a2eebfc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a2eebfc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/mira-merge-config/mira-merge-config/app-config/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6a2eebfc')) {
      api.createRecord('6a2eebfc', component.options)
    } else {
      api.reload('6a2eebfc', component.options)
    }
    module.hot.accept("./r-item-state-dialog.vue?vue&type=template&id=6a2eebfc&scoped=true", function () {
      api.rerender('6a2eebfc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/redactor/views/item/r-item-state-dialog.vue"
export default component.exports